// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__uRlzy","skeleton-loading":"style_skeleton-loading__DbQwh","card_image":"style_card_image__WDkDe"};